import DownloadIcon from "@mui/icons-material/Download";

export const DownloadSiteDetailsText = (
  <>
    <DownloadIcon fontSize="small" />
    &nbsp;Download Site Details
  </>
);
